import React, {useCallback, useState, useRef } from "react";
import './new-location-search.css'
import {
  InputGroup,
  FormControl,
  ListGroup
} from "react-bootstrap";
import './search-location-api.css'
// import { useHistory } from "react-router-dom";
import axios from 'axios';
import _ from "lodash";
import {sort_search_results} from './sort-search-results';
import SyncLoader from "react-spinners/SyncLoader";
import ListItemView from './list_item_view';


const INPUT_TIMEOUT = 400;
const google_map_api_key = "AIzaSyBIPhtOla4zatfw4pnL4ww6OyJBQhftUYc"
const language = 'en'
const proxyurl = "https://cors-anywhere.herokuapp.com/";


export default function NewLocationSearch() {

  const [query, setQuery] = useState('');
  const [predictions, setPredictions] = useState([]);
  const autoCompleteRef = useRef(null);
  const [loading, setLoading] = useState(false);
  // let history = useHistory();



  const debounce = useCallback(
    _.debounce((_searchVal) => {
      // send the server request here
      if (_searchVal.length === 0) {
        setPredictions([])
        return;
      }

      const requestOne = axios.post("https://uae-dentist-backend.herokuapp.com/get-by-name", {query: _searchVal})
      const requestTwo = axios.post("https://uae-dentist-backend.herokuapp.com/staff/get-by-name", {query: _searchVal})
      const requestThree = axios.get( proxyurl+`https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${_searchVal}&types=geocode&components=country:ae&language=${language}&key=${google_map_api_key}`)
      axios.all([requestOne, requestTwo, requestThree]).then(axios.spread((...responses) => {
        setLoading(false);
        console.log(responses[1].data)
        const clinicResponse = responses[0].data || [];
        const dentistResponse = responses[1].data || [];
        const googleResponse = responses[2].data.predictions || [];
        console.log(clinicResponse);
        console.log(dentistResponse);
        console.log(googleResponse);
        const searchPredictions = sort_search_results(clinicResponse, dentistResponse, googleResponse);
        console.log(searchPredictions);
        setPredictions(searchPredictions)
        // use/access the results 
      })).catch(errors => {
        setLoading(false);
        console.log(errors)
      })
    }, INPUT_TIMEOUT),
    []
  );

  const handleChange = (event) => {
    setLoading(true);
    setQuery(event.target.value)
    debounce(event.target.value);
  }



  return (
    <div>

        <InputGroup>
          <FormControl 
              size='lg'
              required 
              placeholder="Enter your location" 
              name="address"
              ref={autoCompleteRef}
              onChange={(event) => handleChange(event) }
              value={query}
              />     
          {/* <InputGroup.Append> */}
            {/* <Button className='m-0'variant="primary" type="submit">
                Search
            </Button> */}
          {/* </InputGroup.Append> */}
        </InputGroup>
        {loading && query.length > 0 &&
              <div className='mt-5'>
                <SyncLoader size={20} margin={3} color={"#123abc"} loading={loading} />
            </div>
        }
      <ListGroup id='list' class="position-absolute">
        {predictions.length > 0 && predictions.map((prediction, idx) => (
          <ListItemView key={idx} prediction={prediction}/>
        ))}
      </ListGroup>

    </div>

  );
}
